module.exports = __webpack_public_path__ + "img/1723614676748-WhatsApp Image 2024-08-14 at 13.45.26 2.jpeg.a70c0b63.webp";